import moment from "moment";
import { Box } from "@mui/material";
import { StatusPill, C } from "../../dashboard/components/DashboardShared";

const BUCKET_PILL_TYPE = {
  critical: "red",
  overdue: "amber",
  pending: "amber",
};

const PILL_TYPE_COLOR = {
  red: C.red,
  amber: C.amber,
  green: C.green,
};

function getBucketKey(bucket) {
  return String(bucket || "").trim().toLowerCase();
}

function formatObligationRightLabel(item) {
  if (typeof item?.days_overdue === "number" && item.days_overdue > 0) {
    return `Overdue ${item.days_overdue}d`;
  }
  if (!item?.due_date) return "-";
  const date = moment(item.due_date);
  return date.isValid() ? `Due ${date.format("DD MMM YYYY")}` : "-";
}

const CriticalOverdueObligationsList = ({ items, maxHeight, onRowClick }) => {
  const safeItems = Array.isArray(items) ? items : [];

  return (
    <Box
      data-table-scroll-root="true"
      className="graph-table-scroll-root"
      sx={{ maxHeight, overflowY: "auto" }}
    >
      {safeItems.length === 0 ? (
        <Box sx={{ padding: "18px 12px", textAlign: "center", color: C.textMuted, fontSize: 12 }}>
          No obligations found
        </Box>
      ) : (
        safeItems.map((item, index) => {
          const bucketKey = getBucketKey(item?.bucket);
          const pillType = BUCKET_PILL_TYPE[bucketKey] || "amber";
          const dotColor = PILL_TYPE_COLOR[pillType] || C.amber;
          return (
            <Box
              key={item?.obligation_id ?? item?.slug ?? index}
              onClick={onRowClick ? () => onRowClick(item) : undefined}
              sx={{ display: "flex", alignItems: "flex-start", gap: "10px", padding: "9px 16px", borderBottom: index < safeItems.length - 1 ? `1px solid ${C.border}` : "none", cursor: onRowClick ? "pointer" : "default" }} >
              <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: dotColor, flexShrink: 0, marginTop: "5px" }} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ fontSize: 13, color: C.textPrimary }}>{item?.title || "-"}</Box>
                {item?.subtitle ? (
                  <Box sx={{ fontSize: "10.5px", color: C.textMuted, marginTop: "2px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} >
                    {item.subtitle}
                  </Box>
                ) : null}
              </Box>
              <Box component="span" sx={{ fontFamily: "Roboto, sans-serif", fontSize: 11, color: C.textSecondary, whiteSpace: "nowrap", marginTop: "2px" }} >
                {formatObligationRightLabel(item)}
              </Box>
              <StatusPill label={item?.bucket || "-"} type={pillType} />
            </Box>
          );
        })
      )}
    </Box>
  );
};

export default CriticalOverdueObligationsList;
